module.exports = __webpack_public_path__ + "media/images/icons/icon-magnifier-fdb7d548ad97cce6c3de78eb4cdb5b12.svg";